<template>
  <div>
    <user />
    <notifications-menu />
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import NotificationsMenu from './NotificationsMenu.vue';
import { User } from '../user';

export default defineComponent({
  name: 'Admin',
  components: {
    NotificationsMenu,
    User,
  },
});
</script>
